export  const SectionsEnum = {
    Accommodation: 'accommodation',
    Flight: 'flight',
    MealType: 'mealType',
    NotExistingSection: 'notExistingSection'
}